module.exports = __webpack_public_path__ + "img/lake-1.372b0713.jpg";